<template>
  <div>
    <div class="row">
      <div
        v-for="n in cards"
        :key="`property-skeleton-${n}`"
        class="col-12 col-sm-6 col-xl-4 property-listing-column tw-mb-[18px] md:tw-mb-[36px]"
      >
        <div
          class="tw-overflow-hidden tw-rounded-[16px] tw-border tw-border-gray-200 tw-bg-white tw-shadow-lg"
        >
          <div class="skeleton tw-aspect-[4/3] tw-w-full tw-bg-gray-100"></div>

          <div class="tw-p-[16px]">
            <div class="tw-mb-[16px] tw-flex tw-gap-[8px]">
              <div
                class="skeleton tw-h-[27px] tw-w-[130px] tw-rounded-full tw-bg-gray-100"
              ></div>
              <div
                class="skeleton tw-h-[27px] tw-w-[110px] tw-rounded-full tw-bg-gray-100"
              ></div>
            </div>

            <div
              class="skeleton tw-mb-[8px] tw-h-[28px] tw-w-3/4 tw-rounded tw-bg-gray-100"
            ></div>
            <div
              class="skeleton tw-mb-[16px] tw-h-[20px] tw-w-2/3 tw-rounded tw-bg-gray-100"
            ></div>
            <div
              class="skeleton tw-h-[24px] tw-w-1/2 tw-rounded tw-bg-gray-100"
            ></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PropertyCardsSkeleton',
  props: {
    cards: {
      type: Number,
      default: 6,
    },
  },
};
</script>
